import React from 'react';
import config from '~/config';
class LoginPage extends React.Component<{}, {}> {
  loginWithGithub(e) {
    e.preventDefault();
    const form = e.target;
    form.setAttribute('action', `${config.API_URL}/signin/github`);
    form.submit();
  }
  render() {
    return (
      <div>
        <h1>Platform Frontend</h1>
        <div>Login on this page</div>
        <form method="POST" name="githubLoginForm" onSubmit={this.loginWithGithub}>
          <input type="hidden" name="scope" value="user:email" />
          <button type="submit" className="btn btn--success">
            Sign in with GitHub
          </button>
        </form>
      </div>
    );
  }
}
export default LoginPage;
